import { IStairConfig, IStepGeometry } from '@stair-craft/common/util';

import { applyExitRiser } from '../shared-exit-riser/exit-riser';

/**
 * Treads for a straight flight. `count` is the number of risers; the stair carries
 * `count - 1` treads (the final riser connects the last tread to the upper floor).
 */
export function generateSteps(count: number, riserHeight: number, treadDepth: number, config: IStairConfig): IStepGeometry[] {
    const steps: IStepGeometry[] = [];

    // count = number of risers. count-1 treads on the stair (upper floor = last tread).
    // Step 0: first tread at y=riserHeight (one riser above floor).
    // Step count-2: last tread at y=(count-1)*riserHeight.
    // The final riser from last tread to floorHeight is the connection to the upper floor.
    for (let i: number = 0; i < count - 1; i++) {
        steps.push({
            index: i,
            position: {
                x: 0,
                y: (i + 1) * riserHeight,
                z: i * treadDepth,
            },
            treadWidth: config.stairWidth,
            treadThickness: config.treadThickness,
            noseLength: config.noseLength,
            rotation: 0,
            isWinder: false,
            isLanding: false,
            treadDepth,
            riserHeight,
        });
    }

    // An opening that runs to the far wall has no slab past the exit.
    applyExitRiser(steps.at(-1), config, config.openingZ + config.openingLength < config.roomLength);

    return steps;
}
